import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  postUploadSchema,
  jobSetupModelSchema,
  licenceDetailsSchema,
} from './post.schema';
import { IProjectEditorState } from './post.slice';

// eslint-disable-next-line import/prefer-default-export
export const usePostUploadForm = (defaultValues: IProjectEditorState) => {
  return useForm<z.infer<typeof postUploadSchema>>({
    resolver: zodResolver(postUploadSchema),
    defaultValues: defaultValues as any,
    mode: 'onChange',
  });
};

export const useLicenceDetailsForm = (defaultValues: IProjectEditorState) => {
  return useForm<z.infer<typeof licenceDetailsSchema>>({
    resolver: zodResolver(licenceDetailsSchema),
    defaultValues: defaultValues as any,
    mode: 'onBlur',
  });
};

export const useJobSetupModelForm = (defaultValues: IProjectEditorState) => {
  return useForm<z.infer<typeof jobSetupModelSchema>>({
    resolver: zodResolver(jobSetupModelSchema),
    defaultValues: defaultValues as any,
    mode: 'onChange',
  });
};
